import { useConnectionCRUDActions } from '@mm/state/actions/ConnectionsCRUDActions';
import { useSalesForceCRUDActions } from '@mm/state/actions/SalesForceCRUDActions';
import { selectSalesForceConnections } from '@mm/state/modules/connectionsTableState/selectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useConnectSalesForce = () => {
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const connections = useSelector(selectSalesForceConnections);
  const accounts = useSelector(
    (state: StoreState) => state.salesForce.accounts,
  );
  const salesForceConnections = useSelector(selectSalesForceConnections);

  const { getSalesForceOauthUrl, getAccounts } = useSalesForceCRUDActions();
  const { create, update } = useConnectionCRUDActions();
  const { retrieveAll } = useConnectionCRUDActions();

  const fetchOAuthUrl = useCallback(
    async (tokenId?: number) => {
      const link = await getSalesForceOauthUrl(tokenId);
      return link;
    },
    [getSalesForceOauthUrl],
  );

  const onTokenConnected = async () => {
    const accountsResponse = await getAccounts(facebookPageId);
    const { id } = accountsResponse[0];
    if (!connections.length) {
      create(facebookPageId, {
        name: 'SalesForce Connection',
        connectionKind: 'salesforce',
        salesforceParams: { accessTokenId: id },
      });
    } else if (
      (connections || []).find(conn => conn.salesforceAccessToken?.id !== id)
    ) {
      connections.forEach(connection => {
        update(facebookPageId, {
          id: connection.id,
          salesforceParams: { accessTokenId: id },
        });
      });
    }
  };

  const retrieveSalesForceAccounts = () => {
    getAccounts(facebookPageId);
  };

  const getSaleForceConnections = async () => {
    retrieveAll(facebookPageId, {
      type: 'salesforce',
      pageSize: 200,
      queryOptions: {
        withVariables: true,
        includedNames: 'all',
        withWebhookErrors: true,
      },
    });
  };

  return {
    accounts,
    fetchOAuthUrl,
    onTokenConnected,
    retrieveSalesForceAccounts,
    salesForceConnections,
    getSaleForceConnections,
  };
};
